import { LoaderFunction } from 'react-router-dom';

import { fetchGraphQL } from 'src/services/contentful/client';
import { GetFlexibleContentHubCollectionQueryVariables } from 'src/graphql/generated/graphql';
import {
  ContentfulFlexibleContentHub,
  GET_FLEXIBLE_CONTENT_HUB_COLLECTION,
  GetFlexibleContentHubCollectionResponse,
} from 'src/graphql/queries/GetFlexibleContentHub';
import { ContentHubType } from 'src/constants';
import { isPreviewMode } from 'src/utils/isPreviewMode';

export const loader: LoaderFunction = async (): Promise<CertificationHubLoaderProps | undefined> => {
  const preview = isPreviewMode();

  const certificationHubData = await getCertificationHubData(ContentHubType.CERTIFICATIONS, preview);

  if (!certificationHubData) {
    throw new Error('Certifications hub was not found');
  }

  return { certificationHubData };
};

const getCertificationHubData = async (
  type: string,
  preview: boolean,
): Promise<ContentfulFlexibleContentHub | undefined> => {
  try {
    const response = await fetchGraphQL<
      GetFlexibleContentHubCollectionResponse,
      Partial<GetFlexibleContentHubCollectionQueryVariables>
    >(GET_FLEXIBLE_CONTENT_HUB_COLLECTION, {
      preview,
      type,
    });

    return response.flexibleContentHubCollection.items[0];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching certification hub data', error);

    return undefined;
  }
};

export interface CertificationHubLoaderProps {
  certificationHubData: ContentfulFlexibleContentHub;
}
